package pro.jayeshseth.animations.itemPlacements.utils

val BASE_FEATURE_ROUTE =
    "features/itemPlacements/src/main/kotlin/pro/jayeshseth/animations/itemPlacements"